import { IProgram, SearchParams } from 'interfaces/program/programInterfaces';
import { moneyRowCurrentView } from 'utils/tablesMethods';

export interface ProgramSelectOption {
  id: string;
  title: string;
  uuid: string;
  allowedSlotPatientTypes?: string[];
}

const uniqueNonEmptyByTitle = <T extends { title: string }>(items: T[]): T[] =>
  items
    .filter((item, index, arr) => arr.findIndex((other) => other.title === item.title && other.title !== '') === index)
    .sort((a, b) => {
      if (a.title > b.title) {
        return 1;
      }
      if (a.title < b.title) {
        return -1;
      }
      return 0;
    });

export const mapProgramsToSelectOptions = (
  programs: IProgram[] | undefined,
  { withBudget = false }: { withBudget?: boolean } = {}
): ProgramSelectOption[] => {
  if (!programs?.length) {
    return [];
  }

  return uniqueNonEmptyByTitle(
    programs.map((item) => ({
      id: item.programUuid,
      title: withBudget
        ? `${item.programTitle}\n(страховая премия - ${moneyRowCurrentView(item.budget)})`
        : item.programTitle,
      uuid: item.programUuid,
      allowedSlotPatientTypes: item.allowedSlotPatientTypes,
    }))
  );
};

export const mapProgramsToCityOptions = (programs: IProgram[] | undefined): SearchParams[] => {
  if (!programs?.length) {
    return [];
  }

  return uniqueNonEmptyByTitle(
    programs.map((item) => ({
      id: item.cityUuid || '',
      title: item.city || '',
      uuid: item.cityUuid || '',
    }))
  );
};
